import {Check} from '@sparkware/app-utils';
import {decodeUriComponentRecursive} from '../../../../utils/url-utils';

export class UriHash {
  constructor(hash: string) {
    this._hash = this._tryDecodeHash(hash || '');
    if(this._hash === '#') {
      this._hash = '';
    }
  }


  get value(): string {
    if(this._hash[0] === '#') {
      return this._hash.substring(1);
    } else {
      return this._hash;
    }
  }

  private _hash: string;

  toString() {
    if(!this._hash) {
      return this._hash;
    }

    if(this._hash[0] === '#') {
      return this._hash;
    } else {
      return '#' + this._hash;
    }
  }

  static areEquals(h1: UriHash, h2: UriHash): boolean {
    if(Check.isNullOrUndefined(h1)) {
      if(Check.isNullOrUndefined(h2)) {
        return true;
      } else {
        return false;
      }
    } else {
      return h1.equals(h2);
    }
  }

  equals(theOther: UriHash) {
    if(Check.isNullOrUndefined(theOther)) {
      return false;
    }

    return this.toString().toLowerCase() === theOther.toString().toLowerCase();
  }

  get isEmpty(): boolean {
    return Check.isEmpty(this._hash);
  }

  private _tryDecodeHash(hash: string): string {
    try {
      return decodeUriComponentRecursive(hash);
    } catch(err) {
      console.error('Failed to decode hash: ' + hash);
      return hash;
    }
  }
}
